import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Star, X, Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

const CATS = [["qualita", "Qualità"], ["puntualita", "Puntualità"], ["cortesia", "Cortesia"]];

function Stars({ value, onChange, size = 7, testid }) {
  return (
    <div className="flex gap-1" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" data-testid={`${testid}-${n}`} onClick={() => onChange(n)} className="transition-transform hover:scale-110">
          <Star className={`h-${size} w-${size}`} style={{ width: size * 4, height: size * 4 }} fill={n <= value ? "#FFD700" : "none"} color={n <= value ? "#FFD700" : "#52525b"} />
        </button>
      ))}
    </div>
  );
}

export default function ServiceReviewDialog({ bookingId, title, onClose, onDone }) {
  const [rating, setRating] = useState(0);
  const [cats, setCats] = useState({ qualita: 0, puntualita: 0, cortesia: 0 });
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!rating) { toast.error("Assegna una valutazione"); return; }
    setBusy(true);
    try {
      await api.post(`/experiences/service-bookings/${bookingId}/review`, { rating, comment, categories: cats });
      toast.success("Grazie per la recensione! ⭐"); onDone();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Errore"); setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-[#141417] border border-white/10 rounded-2xl max-w-md w-full p-5" onClick={(e) => e.stopPropagation()} data-testid="review-dialog">
        <div className="flex items-center justify-between mb-1">
          <div className="font-display font-bold text-lg">Recensisci il servizio</div>
          <button onClick={onClose} data-testid="review-close"><X className="h-5 w-5 text-zinc-400" /></button>
        </div>
        <div className="text-xs text-[#00E676] flex items-center gap-1 mb-3"><ShieldCheck className="h-3.5 w-3.5" /> Prenotazione verificata</div>
        <div className="text-sm text-zinc-400 mb-3">{title}</div>

        <div className="text-sm font-semibold mb-1">Valutazione complessiva</div>
        <Stars value={rating} onChange={setRating} size={8} testid="review-rating" />

        <div className="mt-4 space-y-2">
          {CATS.map(([k, l]) => (
            <div key={k} className="flex items-center justify-between">
              <span className="text-sm text-zinc-300">{l}</span>
              <Stars value={cats[k]} onChange={(v) => setCats((c) => ({ ...c, [k]: v }))} size={4} testid={`review-cat-${k}`} />
            </div>
          ))}
        </div>

        <Textarea data-testid="review-comment" value={comment} onChange={(e) => setComment(e.target.value)} rows={3} placeholder="Racconta com'è andata…" className="bg-[#0A0A0C] border-white/10 mt-4 resize-none" />
        <Button data-testid="review-submit" onClick={submit} disabled={busy} className="mt-4 w-full bg-[#00E676] text-black font-semibold rounded-full">
          {busy ? <><Loader2 className="h-4 w-4 mr-1 animate-spin" /> Invio…</> : "Pubblica recensione"}
        </Button>
      </div>
    </div>
  );
}
